import { gql } from 'graphql-tag';

export const GET_ACCOUNT_PAYABLE_SUPPLIERS = gql`
  query Idaa8f2aa3c52ecd2a7ae94dbdccb3ff1f(
    $accountPayableId: ID!
    $after: ID
    $filter: SupplierFilter!
  ) {
    __typename
  }
`;
